module.exports = __webpack_public_path__ + "static/high-five-d075a51e22917973bea083ff7ac608b7.gif";